var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 269 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.352 37.8519C121.679 37.8519 109.131 40.348 97.4229 45.1976C85.7149 50.0471 75.0769 57.1553 66.116 66.1161C57.1551 75.077 50.047 85.7151 45.1974 97.423C40.3479 109.131 37.8518 121.679 37.8518 134.352C37.8518 147.024 40.3479 159.573 45.1974 171.281C50.047 182.989 57.1552 193.627 66.116 202.588C75.0769 211.549 85.7149 218.657 97.4229 223.506C109.131 228.356 121.679 230.852 134.352 230.852L134.352 205.843C124.963 205.843 115.667 203.994 106.993 200.401C98.3197 196.808 90.4386 191.542 83.8001 184.904C77.1616 178.265 71.8956 170.384 68.3028 161.71C64.7101 153.037 62.8609 143.74 62.8609 134.352C62.8609 124.964 64.7101 115.667 68.3028 106.994C71.8956 98.3199 77.1616 90.4388 83.8001 83.8002C90.4386 77.1617 98.3197 71.8957 106.993 68.3029C115.667 64.7102 124.963 62.861 134.352 62.861L134.352 37.8519Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.181 228.113C179.079 222.781 198.421 209.952 211.85 191.852L191.765 176.95C181.816 190.359 167.488 199.863 151.265 203.813L157.181 228.113Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M223.187 172.043C228.136 160.377 230.74 147.851 230.848 135.179C230.957 122.507 228.568 109.937 223.819 98.1882L200.633 107.56C204.151 116.265 205.921 125.576 205.84 134.964C205.76 144.352 203.831 153.633 200.164 162.275L223.187 172.043Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.51 75.0878C197.279 58.0863 178.741 46.0007 157.846 40.7557L151.757 65.0123C167.237 68.8979 180.971 77.8514 190.772 90.4468L210.51 75.0878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner);
export default __webpack_public_path__ + "static/media/LoadingSpinner.27e0df2f64ebdd79410400b925fe223d.svg";
export { ForwardRef as ReactComponent };